<!-- ── DARK HERO ──────────────────────────────────────────────── -->
<div class="relative overflow-hidden bg-[#0f0d0c] px-7 pt-8 pb-7">

  <!-- Ambient orbs -->
  <div class="absolute -top-20 -right-20 w-72 h-72 rounded-full bg-brand/20 blur-3xl pointer-events-none"></div>
  <div class="absolute -bottom-12 left-1/4 w-56 h-56 rounded-full bg-amber-400/8 blur-3xl pointer-events-none"></div>

  <!-- Confetti burst — one-shot on open, bursts from centre of hero -->
  <!-- Brand red pieces -->
  <div class="conf" style="--tx:-82px;--ty:-88px;--c:#c41230;--r:140deg;--d:0ms;--w:4px;--h:9px"></div>
  <div class="conf" style="--tx:-20px;--ty:-105px;--c:#c41230;--r:-80deg;--d:60ms;--w:6px;--h:6px"></div>
  <div class="conf" style="--tx:72px;--ty:-90px;--c:#c41230;--r:200deg;--d:25ms;--w:4px;--h:10px"></div>
  <div class="conf" style="--tx:95px;--ty:20px;--c:#c41230;--r:-160deg;--d:80ms;--w:5px;--h:7px"></div>
  <!-- Amber/gold pieces -->
  <div class="conf" style="--tx:-55px;--ty:-100px;--c:#f59e0b;--r:-110deg;--d:15ms;--w:5px;--h:8px"></div>
  <div class="conf" style="--tx:50px;--ty:-102px;--c:#f59e0b;--r:90deg;--d:45ms;--w:6px;--h:6px"></div>
  <div class="conf" style="--tx:-100px;--ty:-30px;--c:#f59e0b;--r:-50deg;--d:70ms;--w:4px;--h:9px"></div>
  <div class="conf" style="--tx:30px;--ty:80px;--c:#f59e0b;--r:170deg;--d:35ms;--w:5px;--h:5px"></div>
  <!-- White pieces -->
  <div class="conf" style="--tx:10px;--ty:-108px;--c:#ffffff;--r:60deg;--d:5ms;--w:4px;--h:7px"></div>
  <div class="conf" style="--tx:-90px;--ty:30px;--c:#ffffff;--r:-130deg;--d:55ms;--w:5px;--h:8px"></div>
  <div class="conf" style="--tx:102px;--ty:-45px;--c:#ffffff;--r:110deg;--d:20ms;--w:4px;--h:9px"></div>
  <div class="conf" style="--tx:-35px;--ty:88px;--c:#ffffff;--r:-70deg;--d:75ms;--w:6px;--h:6px"></div>
  <!-- Gold/cream pieces -->
  <div class="conf" style="--tx:65px;--ty:72px;--c:#fde68a;--r:240deg;--d:40ms;--w:4px;--h:8px"></div>
  <div class="conf" style="--tx:-68px;--ty:65px;--c:#fde68a;--r:-200deg;--d:10ms;--w:5px;--h:6px"></div>
  <div class="conf" style="--tx:108px;--ty:10px;--c:#fca5a5;--r:80deg;--d:50ms;--w:4px;--h:7px"></div>
  <div class="conf" style="--tx:-108px;--ty:-60px;--c:#fca5a5;--r:-95deg;--d:30ms;--w:5px;--h:9px"></div>

  <!-- Close -->
  <button (click)="dismiss()"
          class="absolute top-4 right-4 w-7 h-7 rounded-full bg-white/10 hover:bg-white/20
                 flex items-center justify-center transition-colors z-10">
    <mat-icon class="!text-[14px] !size-[14px] text-white/50">close</mat-icon>
  </button>

  <!-- Eyebrow -->
  <p class="text-[10px] font-semibold uppercase tracking-[0.22em] text-white/35 mb-5 relative z-10">
    Referral programme
  </p>

  <!-- Earning potential -->
  <div class="mb-1 relative z-10">
    @if (earningsPotential) {
      <p class="font-black leading-none tracking-tighter text-white"
         style="font-size: clamp(2.6rem, 10vw, 3.4rem)">
        {{earningsPotential}}
      </p>
    }
  </div>
  <p class="text-white/40 text-sm mb-7 relative z-10">in referral earnings every month</p>

  <!-- Mini steps -->
  <div class="flex flex-col gap-y-3 relative z-10">
    <div class="flex items-center gap-x-3">
      <div class="w-7 h-7 rounded-full bg-white/10 border border-white/10 flex items-center justify-center shrink-0">
        <mat-icon class="!text-[13px] !size-[13px] text-white/60">link</mat-icon>
      </div>
      <p class="text-white/55 text-[13px]">Share your personal referral link</p>
    </div>
    <div class="flex items-center gap-x-3">
      <div class="w-7 h-7 rounded-full bg-white/10 border border-white/10 flex items-center justify-center shrink-0">
        <mat-icon class="!text-[13px] !size-[13px] text-white/60">person_add</mat-icon>
      </div>
      <p class="text-white/55 text-[13px]">Your referral subscribes to any plan</p>
    </div>
    <div class="flex items-center gap-x-3">
      <div class="w-7 h-7 rounded-full bg-white/10 border border-white/10 flex items-center justify-center shrink-0">
        <mat-icon class="!text-[13px] !size-[13px] text-white/60">payments</mat-icon>
      </div>
      <p class="text-white/55 text-[13px]">You get paid. No cap, no limits.</p>
    </div>
  </div>
</div>

<!-- ── LIGHT BOTTOM ───────────────────────────────────────────── -->
<div class="bg-white px-6 pt-5 pb-5">
  <!-- Primary CTA -->
  <button (click)="onStartReferring()" matRipple
          class="animate-shine w-full flex items-center justify-center gap-x-2
                 py-3 px-6 rounded-full mb-3
                 bg-gradient-to-r from-brand to-[#a8112c]
                 text-white font-semibold text-sm shadow-sm
                 hover:opacity-90 transition-opacity">
    <mat-icon class="!text-[16px] !size-[16px]">redeem</mat-icon>
    Start Referring Now
  </button>

  <!-- Secondary CTA -->
  <button (click)="onLearnMore()"
          class="w-full flex items-center justify-center gap-x-1.5
                 py-2.5 px-6 rounded-full mb-4
                 border border-line bg-white
                 text-ink-muted hover:text-ink hover:bg-sand-soft
                 text-sm font-medium transition-colors">
    Learn about the programme
    <mat-icon class="!text-[13px] !size-[13px]">open_in_new</mat-icon>
  </button>

  <!-- Dismiss -->
  <button (click)="dismiss()"
          class="w-full text-center text-xs text-ink-soft/50 hover:text-ink-soft transition-colors py-0.5">
    Maybe later
  </button>
</div>
